import { render } from "./FabricantesFabricantes.vue?vue&type=template&id=1abea47c&scoped=true"
import script from "./FabricantesFabricantes.vue?vue&type=script&lang=ts"
export * from "./FabricantesFabricantes.vue?vue&type=script&lang=ts"

import "./FabricantesFabricantes.vue?vue&type=style&index=0&id=1abea47c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1abea47c"

export default script